module.exports = __webpack_public_path__ + "static/media/teacher-mathematics.e5d6c16c.png";